import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {  EventWithVenue, BookingOffice } from 'app/models';
import { Observable } from 'rxjs/Observable';
import { StringDatePipe } from '../../../ui-helper/string-date.pipe';

@Component({
	selector: 'reporting-list-presentation',
	template: require("./reporting-list.presentation.html"),
	styles: [require("./reporting-list.presentation.scss")]
})
export class ReportingListPresentation {
	public eventsComboBox;
	public bookingOfficesComboBox;
	public vvkListeShowVenue = false;
	public vvklisteVon;
	public vvklisteBis;

	public evkUebVon;
	public evkUebBis;

	public detailVkUebVon;
	public detailVkUebBis;
	public detailVkUebKostenstellen;
	public detailVkUebInclStorno;

	public vvkAbrechnungVon;
	public vvkAbrechnungBis;
	public vvkAbrechnungInitialized;

	@Output() einlassliste: EventEmitter<EventWithVenue> = new EventEmitter<EventWithVenue>();
	@Output() vvkListe: EventEmitter<any>  = new EventEmitter();
	@Output() evkUebDownloadClicked: EventEmitter<any> = new EventEmitter();
	@Output() detailVkUebDownloadClicked: EventEmitter<any>  = new EventEmitter();
	@Output() barcodes: EventEmitter<EventWithVenue> = new EventEmitter<EventWithVenue>();

	@Output() veranstalterabrechnungDownloadClicked: EventEmitter<any> = new EventEmitter();

	@Output() vvkSteAbrClicked: EventEmitter<any> = new EventEmitter();

	private _events: EventWithVenue[];
	@Input() set events(events: EventWithVenue[]) {
		this._events = events;
		if (!events) return;
		this.eventsComboBox = events.map(event => ({
			id: event.uuidEvent,
			text: event.title + (event.subtitle ? " - " + event.subtitle : "")
				+ (event.begin ? " • " + new StringDatePipe().transform(event.begin, null) : ""),
			html: this.buildComboBoxOptionHtmlString(event)
		}));

		this.eventsComboBox.sort((data, otherData) => data.text.localeCompare(otherData.text, 'de'));
	}

	private _bookingOffices: BookingOffice[];
	@Input() set bookingOffices(bookingOffices: BookingOffice[]) {
		this._bookingOffices = bookingOffices;
		if (!bookingOffices) return;
		this.bookingOfficesComboBox = bookingOffices.map(bookingOffice => ({
			id: bookingOffice.uuid,
			text: bookingOffice.name,
		}));

		this.bookingOfficesComboBox.sort((data, otherData) => data.text.localeCompare(otherData.text, 'de'));
		this.vvkAbrechnungInitialized = true;
	}

	constructor() {
	}

	downloadEinlassliste(uuid) {
		this.einlassliste.emit(
			this._events.filter(e => e.uuidEvent === uuid)[0]
		);
	}
	downloadBarcodes(uuid) {
		this.barcodes.emit(
			this._events.filter(e => e.uuidEvent === uuid)[0]
		);
	}
	downloadVVK() {
		this.vvkListe.emit({
			from: this.vvklisteVon,
			to: this.vvklisteBis,
			showVenue: this.vvkListeShowVenue
		});
	}

	downloadEvkUeb() {
		this.evkUebDownloadClicked.emit({
			from: this.evkUebVon,
			to: this.evkUebBis,
		});
	}

	downloadVeranstalterabrechnung(uuid) {
		this.veranstalterabrechnungDownloadClicked.emit(
			this._events.filter(e => e.uuidEvent === uuid)[0]
		);
	}

	downloadDetailVVK() {
		this.detailVkUebDownloadClicked.emit({
			from: this.detailVkUebVon,
			to: this.detailVkUebBis,
			costcenters: this.detailVkUebKostenstellen,
			withCorrections: this.detailVkUebInclStorno,
		});
	}

	downloadVorverkaufsstellenabrechnung(uuid, abrechnungsSatz) {
		this.vvkSteAbrClicked.emit({
			from: this.vvkAbrechnungVon,
			to: this.vvkAbrechnungBis,
			bookingOfficeUuid: uuid,
			bookingOfficeName: this._bookingOffices.filter(bo => bo.uuid === uuid)[0].name,
			abrechnungsSatz: abrechnungsSatz,
		});
	}

	buildComboBoxOptionHtmlString(event: EventWithVenue): string {
		const titlePart: string = event.title + (event.subtitle ? " - " + event.subtitle : "")

		const dateString: string = new StringDatePipe().transform(event.begin, null);

		const htmlString: string = `
			<div style="display: flex; justify-content: space-between;">
				<div style="width: 75%">${titlePart}</div>
				<div style="width: 25%; text-align: right;">${dateString}</div>
			</div>
		`

		return htmlString;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/reporting/reporting-list/reporting-list.presentation.ts